import { useDispatch, useSelector } from 'react-redux'
import { loadEnums } from 'enums/state/actions'
import { useQuery } from '@cbgms/base/http/use-query'
import { Time } from '@carsys/enums/time'
import { IRootReducerState } from 'state/reducers'

const useSupportEnums = () => {
  const dispatch = useDispatch()
  const isLoggedIn = useSelector<IRootReducerState>(state => state.auth.authenticated)

  return useQuery(
    ['enums', 'support'],
    async () => {
      const { Data } = await dispatch(loadEnums())
      return Data
    },
    {
      cacheTime: Time.Hour * 24,
      staleTime: Time.Hour * 24,
      refetchOnWindowFocus: false,
      enabled: !!isLoggedIn
    }
  )
}

export default useSupportEnums
